// extracted by mini-css-extract-plugin
export default {"container":"bankInformation_container__9qVL1","innerCard":"bankInformation_innerCard__OKEfp","infoBlock":"bankInformation_infoBlock__RIr8l"};